import * as React from 'react'
import { AppIcon, type AppIconSize } from './icon'
import { mdiPlus } from '@mdi/js'

import { cn } from '../../lib/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip'

export type AddIconButtonProps = {
  tooltip: string
  onClick: () => void
  testId: string
  disabled?: boolean
  className?: string
  size?: AppIconSize
}

export const AddIconButton = React.forwardRef<HTMLButtonElement, AddIconButtonProps>(
  function AddIconButton(
    { tooltip, onClick, testId, disabled = false, className, size = 'sm' },
    ref,
  ) {
    return (
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <button
            ref={ref}
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-label={tooltip}
            data-testid={`${testId}-btn`}
            className={cn(
              'inline-flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground transition-colors',
              'hover:bg-muted hover:text-foreground active:bg-muted/80',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              'disabled:cursor-not-allowed disabled:opacity-50',
              className,
            )}
          >
            <AppIcon path={mdiPlus} size={size} tone="inherit" />
          </button>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    )
  },
)
